import React, { useRef } from 'react';
import { SplideSlide, Splide, SplideTrack } from '@splidejs/react-splide';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';
import Button from '@nubank/nuds-web/components/Button/Button';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

import carouselItems from './carouselItems.json';
import DesktopFeatureCard from './DesktopFeatureCard';

const StyledButton = styled(Button)`
  background: #4C2796;
  margin-bottom: 24px;

  :disabled {
    color: white;
    background: #A376FF;
  }

  svg path {
    fill: white;
  }
`;

const ArrowButtonContainer = styled(Box)`
  display: flex;
  gap: 20px;
  margin-top: 40px;
`;

const StyledSplide = styled(Splide)`
  .splide__slide {
    transform: scale(1);
    transition: transform 0.1s ease;
  }

  .splide__slide.is-next {
    transform: scale(0.95);
  }
  
  .splide__slide.is-prev {
    transform: scale(0.95);
  }
`;

const StyledBox = styled(Box)`
  @media (width >= 1800px) {
    padding-left: 200px;
  }
`;

function DesktopSplideCarousel() {
  const ref = useRef();

  return (
    <StyledBox
      display={{ xs: 'none', md: 'block' }}
      paddingLeft={{ lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 12' }}
          gridRow="1"
        >
          <StyledSplide
            ref={ref}
            hasTrack={false}
            aria-label="features-desktop-slides"
            options={{
              pagination: false,
              arrows: 2,
              perPage: 2,
              perMove: 1,
              focus: 'left',
              fixedWidth: '70%',
              trimSpace: false,
              gap: '40px',
            }}
          >
            <SplideTrack>
              {carouselItems.map(item => (

                <SplideSlide key={item.id}>
                  <DesktopFeatureCard {...item} />
                </SplideSlide>

              ))}
            </SplideTrack>

            {/* ARROW BTNS */}

            <ArrowButtonContainer className="splide__arrows">
              <StyledButton
                className="splide__arrow splide__arrow--prev"
                iconProps={{ name: 'arrow-left', title: 'Anterior' }}
              />
              <StyledButton
                className="splide__arrow splide__arrow--next"
                iconProps={{ name: 'arrow-right', title: 'Siguente' }}
              />
            </ArrowButtonContainer>
          </StyledSplide>
        </Grid.Child>
      </Grid>

    </StyledBox>
  );
}

export default DesktopSplideCarousel;
